import ProductGallery from "../../ProductGallery";
import { PageMeta, BreadcrumbJsonLd } from "../../../seo";

export default function WholeSale() {
  return (
    <>
      <PageMeta
        title="批發產品"
        description="貓山王朝批發服務｜馬來西亞貓山王、黑刺榴槤鮮果、急凍產品批發｜香港餐飲業供應"
        canonicalPath="/wholesale"
      />
      <BreadcrumbJsonLd
        items={[
          { name: "首頁", path: "/" },
          { name: "批發產品", path: "/wholesale" },
        ]}
      />
      <ProductGallery />
    </>
  );
}
